// extracted by mini-css-extract-plugin
export default {"circularProgress":"CircularLoading_circularProgress__kni90","color-change":"CircularLoading_color-change__a1ovm","component":"CircularLoading_component__gVhYK"};